module.exports = __webpack_public_path__ + "static/media/koala.495bdb05.png";